import styled, { keyframes, css } from "styled-components"
import upperFirst from "lodash/upperFirst"
import camelCase from "lodash/camelCase"

import * as Icons from "./assets/js"

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
const animation = () =>
  css`
    animation: ${rotate} 2s linear infinite;
  `

const Container = styled.div`
  position: relative;
  display: inline-block;
  height: ${(props) => props.size && props.size}px;
  width: ${(props) => props.size && props.size}px;
  padding: 0;
  color: ${(props) => (props.color ? props.color : "inherit")};
  ${(props) => props.size && `font-size: ${props.size}px;`}
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
  & > svg {
    ${(props) => props.spin && animation}
  }
`
const iconSize = {
  sm: 12,
  md: 16,
  lg: 20,
}

const Icon = ({
  color,
  size,
  spin,
  iconName,
  left = 0,
  top = 0,
  height = "1em",
  width = "1em",
  ...rest
}) => {
  const IconComponent = Icons[upperFirst(camelCase(iconName))]
  return (
    <Container
      color={color}
      size={iconSize[size] || size || iconSize.sm}
      spin={spin}
      {...rest}>
      <IconComponent
        style={{
          top,
          left,
          width,
          height,
          position: "absolute",
        }}
      />
    </Container>
  )
}

export default Icon
